import React from "react";
import styled from "styled-components";

import GlobalStyles from "../styles/GlobalStyles";
import Typography from "../styles/Typography";
import Nav from "./Nav";
import Footer from "./Footer";
import "normalize.css";

const SiteBorderStyled = styled.div`
  /* box-shadow: 0 0 5px 3px rgba(0, 0, 0, 0.044); */
`;
const ContentStyled = styled.div``;
export default function Layout({ children }) {
  return (
    <>
      <GlobalStyles />
      <Typography />
      <SiteBorderStyled>
        <ContentStyled>
          <Nav />
          {children}
          <Footer />
        </ContentStyled>
      </SiteBorderStyled>
    </>
  );
}
